/*
 * @Author: Ygm
 * @Date: 2024-07-03 10:35:30
 * @LastEditors: Ygm
 * @LastEditTime: 2024-08-01 09:32:38
 * @Description: 提示配置
 */
const PRIVATE_DOMAIN_NAME = '国家教育考试综合管理平台（专网地址：https://glptzw.neea.edu.cn）'

export { PRIVATE_DOMAIN_NAME }



// WEBPACK FOOTER //
// ./src/promptConfig.js